export default "__VITE_ASSET__DIOwb_8G__"